/* ============================================================
   KORENA - cart drawer (Dossier).
   Progressive enhancement over Shopify's native cart:
   - the nav bag icon opens a slide-in drawer instead of /cart
   - any add-to-cart form adds via AJAX and opens the drawer
   - quantity, remove and the protection toggle update OPTIMISTICALLY
     (instant UI), then reconcile with the server in the background,
     so nothing waits on a round-trip.
   - shipping protection ($4.99) is OPT-IN: off by default, added only
     when the customer flips the toggle; choice remembered for the
     session. It is excluded from the item list and the bag count.
   - payment-method icons sit under the checkout button.
   If JS fails or is off, the bag icon still links to /cart and the
   forms still POST to /cart/add. Nothing here blocks a sale.
   ============================================================ */
(function () {
  var PROTECT_VID = 53411405201519;            // "Shipping Protection" variant
  var PROTECT_PRICE = 499;                      // cents
  var PROTECT_OFF_KEY = "kcart_protect_off";    // session opt-out flag
  var SHIP_FREE_OVER = 3500;                    // cents: free AU shipping threshold ($35)
  /* What each bundle line contains, shown under the title in the drawer.
     Groups mirror the product page: { label, tag, items:[[name, tag], ...] }.
     A tag of "Free" marks what is genuinely included at no charge. */
  var INCLUDES = {
    "the-founding-drop": [
      { label: "30-day supply", tag: "", items: [
        ["4 KORENA Hydrogel Masks", ""],
        ["4 Bonus Treatments", "Free"]
      ] },
      { label: "Glass Skin Kit", tag: "Free", items: [
        ["Peel Serum", ""],
        ["KORENA Spa Headband", ""],
        ["Portable Facial Mist Sprayer", ""],
        ["Reusable Gel Eye Mask", ""],
        ["$30 KORENA Credit", ""]
      ] }
    ]
  };
  function tagHTML(t) { return t ? '<b class="kcart__inc-tag">' + t + '</b>' : ''; }
  function includesHTML(handle) {
    var groups = INCLUDES[handle];
    if (!groups) return "";
    return '<div class="kcart__inc">' + groups.map(function (g) {
      return '<div class="kcart__inc-group">'
        + '<div class="kcart__inc-head"><span>' + g.label + '</span>' + tagHTML(g.tag) + '</div>'
        + '<ul class="kcart__inc-list">' + g.items.map(function (r) {
            return '<li><span>' + r[0] + '</span>' + tagHTML(r[1]) + '</li>';
          }).join("") + '</ul>'
        + '</div>';
    }).join("") + '</div>';
  }
  function extrasHTML(item) {
    var value = item.properties && (item.properties['Free gifts per kit'] || item.properties['Extras per kit']);
    if (typeof value !== 'string' || !value.trim()) return '';
    var escaped = value.replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
    if (Number(item.variant_id) === 67781155487855) {
      var gifts = value.split(';').map(function(gift){return gift.trim();}).filter(Boolean).map(function(gift){return gift.replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});});
      return '<div class="kcart__inc"><div class="kcart__inc-group"><div class="kcart__inc-head"><span>Your LED mask</span></div><ul class="kcart__inc-list"><li><span>1 × LED mask</span></li></ul></div><div class="kcart__inc-group"><div class="kcart__inc-head"><span>Gifts per kit</span>' + tagHTML('FREE') + '</div><ul class="kcart__inc-list">'
        + gifts.map(function(gift){return '<li><span>'+gift+'</span></li>';}).join('')
        + '</ul></div></div>';
    }
    return '<details class="kcart__variant"><summary>Included extras per kit</summary><p>' + escaped + '</p></details>';
  }
  function checkoutProperties(item) {
    var properties = Object.assign({}, item.properties || {}), changed = false;
    var led = Number(item.variant_id)===67781155487855 || Number(item.variant_id)===67952743579759;
    var keys = led ? {'Offer':'_Offer','Included per item':'_Included per item','Extras per kit':'Free gifts per kit'} : Number(item.variant_id)===54304421412975 ? {'Bundle':'_Bundle'} : {};
    Object.keys(keys).forEach(function(key){if(Object.prototype.hasOwnProperty.call(properties,key)){properties[keys[key]]=properties[key];delete properties[key];changed=true;}});
    return changed ? properties : null;
  }
  function comparisonTotal(item, compareAt) {
    var total = Math.max((Number(compareAt)||0) * item.quantity, Number(item.original_line_price)||0);
    return total > item.final_line_price ? total : 0;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { extrasHTML: extrasHTML, comparisonTotal: comparisonTotal, checkoutProperties: checkoutProperties };
  if (typeof document === 'undefined') return;

  function ready(fn) {
    if (document.readyState !== "loading") { fn(); }
    else { document.addEventListener("DOMContentLoaded", fn); }
  }
  function money(cents) {
    var n = (Number(cents) / 100).toFixed(2);
    return "$" + n.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  function thumb(url) {
    if (!url) return "";
    return url.replace(/(\.[a-z]+)(\?|$)/i, "_140x$1$2");
  }
  function isProtect(it) { return it.variant_id === PROTECT_VID; }
  function isFounding(it) { return /founding/i.test((it.variant_title || "") + " " + (it.product_title || "")); }
  function hasFounding(cart) { return (cart && cart.items || []).some(isFounding); }
  /* Free-shipping progress bar. Fills toward $35; at/over, it turns green and celebrates.
     The Founding Drop ($39.90) always clears the bar. Rendered into the drawer's
     #kcartShip and any [data-kship] element on the page (e.g. the PDP buy box). */
  function shipBarHTML(cents) {
    var pct = Math.min(100, Math.round((cents / SHIP_FREE_OVER) * 100));
    var unlocked = cents >= SHIP_FREE_OVER;
    var label = unlocked
      ? "Free shipping over $35 \u00b7 Unlocked"
      : "Free shipping over $35 \u00b7 You're " + money(SHIP_FREE_OVER - cents) + " away";
    return '<div class="kship__row' + (unlocked ? " is-unlocked" : "") + '">'
      + '<span class="kship__label">' + label + (unlocked ? ' <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M2.5 8.5l3.5 3.5 7-8"/></svg>' : '') + '</span>'
      + '<span class="kship__track"><span class="kship__fill" style="width:' + pct + '%"></span></span>'
      + '</div>';
  }
  function updateShipBars(cents) {
    var els = document.querySelectorAll("#kcartShip, [data-kship]");
    Array.prototype.forEach.call(els, function (el) { el.innerHTML = shipBarHTML(Math.max(0, cents)); });
    var sv = document.getElementById("cartShipV");
    if (sv) sv.textContent = cents >= SHIP_FREE_OVER ? "Free" : "$8.99 \u00b7 free over $35";
  }
  function findProtect(cart) { return (cart.items || []).filter(isProtect)[0] || null; }
  function realItems(cart) { return (cart.items || []).filter(function (it) { return !isProtect(it); }); }
  function realCount(cart) { return realItems(cart).reduce(function (s, it) { return s + it.quantity; }, 0); }
  function protectOff() { try { return sessionStorage.getItem(PROTECT_OFF_KEY) === "1"; } catch (e) { return false; } }
  function setProtectOff(v) { try { sessionStorage.setItem(PROTECT_OFF_KEY, v ? "1" : "0"); } catch (e) {} }
  function post(url, payload) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  var SHIELD = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6l7-3z"></path><path d="M9 12l2 2 4-4"></path></svg>';

  function protectRow(on, foundingFree, ledFree) {
    /* With the Founding Drop in the bag, protection is INCLUDED free: price struck
       through, switch locked on, and the paid variant is never added to the cart. */
    var desc = foundingFree
      ? (ledFree ? "Included free with your LED mask." : "Included free with your Founding Drop.")
      : "Free replacement for lost, stolen or damaged orders.";
    var price = foundingFree
      ? '<span class="kcart__protect-p"><s>$4.99</s> <b class="kcart__protect-free">FREE</b></span>'
      : '<span class="kcart__protect-p">$4.99</span>';
    var sw = foundingFree
      ? '<button type="button" class="kcart__protect-sw is-locked" role="switch" aria-checked="true" disabled aria-label="Shipping protection included free"><span class="kcart__protect-knob"></span></button>'
      : '<button type="button" class="kcart__protect-sw" data-kcart-protect role="switch" aria-checked="' + (on ? "true" : "false") + '" aria-label="Add shipping protection"><span class="kcart__protect-knob"></span></button>';
    return '<div class="kcart__protect-row">'
      + '<span class="kcart__protect-ic">' + SHIELD + '</span>'
      + '<div class="kcart__protect-txt">'
      +   '<span class="kcart__protect-t">Shipping Protection</span>'
      +   '<span class="kcart__protect-d">' + desc + '</span>'
      + '</div>'
      + price
      + sw
      + '</div>';
  }

  ready(function () {
    if (document.getElementById("kcart")) return;

    // ---- Build drawer shell ----
    var scrim = document.createElement("div");
    scrim.className = "kcart-scrim"; scrim.id = "kcartScrim"; scrim.setAttribute("data-open", "false");

    var panel = document.createElement("aside");
    panel.className = "kcart"; panel.id = "kcart";
    panel.setAttribute("data-open", "false");
    panel.setAttribute("aria-label", "Shopping bag");
    panel.setAttribute("aria-hidden", "true");
    panel.setAttribute("role", "dialog");
    panel.setAttribute("aria-modal", "true");
    panel.innerHTML =
        '<div class="kcart__head">'
      +   '<span class="kcart__title"><span class="kcart__count" id="kcartCount" aria-label="Items in bag"></span>Your bag</span>'
      +   '<button class="k-iconbtn" type="button" aria-label="Close bag" data-kcart-close>'
      +     '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6L6 18"></path></svg>'
      +   '</button>'
      + '</div>'
      + '<div class="kcart__body" id="kcartBody"><div class="kcart__loading">Loading your bag...</div></div>'
      + '<div class="kcart__foot" id="kcartFoot" hidden>'
      +   '<div class="kcart__protect" id="kcartProtect"></div>'
      +   '<div class="kcart__subtotal"><span>Subtotal</span><span id="kcartSubtotal"></span></div>'
      +   '<a class="k-btn k-btn--primary k-btn--lg k-btn--block" id="kcartCheckout" href="/checkout">Checkout</a>'
      +   '<div class="kcart__pay" id="kcartPay"></div>'
      +   '<a class="kcart__viewcart" href="/cart">View full bag</a>'
      + '</div>';

    document.body.appendChild(scrim);
    document.body.appendChild(panel);

    var body = document.getElementById("kcartBody");
    var foot = document.getElementById("kcartFoot");
    var subtotalEl = document.getElementById("kcartSubtotal");
    var countEl = document.getElementById("kcartCount");
    var protectEl = document.getElementById("kcartProtect");
    var lastFocus = null;
    var lastCart = null;
    var optimisticTotal = 0;
    var addingProtect = false;
    var qtyTimers = {};

    // payment icons: copy once from the Liquid-rendered source block
    var paySrc = document.getElementById("kcart-payicons-src");
    var payEl = document.getElementById("kcartPay");
    if (paySrc && payEl) payEl.innerHTML = paySrc.innerHTML;

    function lock(on) { document.body.style.overflow = on ? "hidden" : ""; }
    function open() {
      lastFocus = document.activeElement;
      scrim.dataset.open = "true"; panel.dataset.open = "true";
      panel.setAttribute("aria-hidden", "false"); lock(true);
      var c = panel.querySelector("[data-kcart-close]"); if (c) c.focus();
    }
    function close() {
      scrim.dataset.open = "false"; panel.dataset.open = "false";
      panel.setAttribute("aria-hidden", "true"); lock(false);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function updateBadge(n) {
      var b = document.getElementById("bagCount");
      if (!b) return;
      b.textContent = n;
      b.style.display = n > 0 ? "" : "none";
    }
    function setCounts(n) {
      countEl.textContent = n ? String(n) : "";
      countEl.hidden = !n;
      updateBadge(n);
    }
    function setSubtotal(cents) { optimisticTotal = cents; subtotalEl.textContent = money(cents); updateShipBars(cents); }
    function bumpSubtotal(delta) { optimisticTotal = Math.max(0, optimisticTotal + delta); subtotalEl.textContent = money(optimisticTotal); updateShipBars(optimisticTotal); }
    function unitOf(li) { return parseInt(li.getAttribute("data-unit"), 10) || 0; }

    function getCart() { return fetch("/cart.js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }).then(function(cart){
      var updates=(cart.items||[]).map(function(item){return {item:item,properties:checkoutProperties(item)};}).filter(function(entry){return entry.properties!==null;});
      return updates.reduce(function(chain,entry){return chain.then(function(current){return post('/cart/change.js',{id:entry.item.key,quantity:entry.item.quantity,properties:entry.properties}).then(function(updated){return updated&&Array.isArray(updated.items)?updated:current;}).catch(function(){return current;});});},Promise.resolve(cart)).then(function(current){return updates.length ? fetch("/cart.js",{headers:{"Accept":"application/json"}}).then(function(r){return r.json();}).catch(function(){return current;}) : current;});
    }); }
    function refresh() { return getCart().then(render); }

    // Reconcile totals/badge after a background change WITHOUT rebuilding the list/toggle
    function syncTotals() {
      return getCart().then(function (cart) {
        lastCart = cart;
        setCounts(realCount(cart));
        setSubtotal(cart.total_price);
        if (realItems(cart).length === 0) { render(cart); }   // empty / strip orphan protection
      }).catch(function () {});
    }

    function addProtectSilent() {
      if (addingProtect) return Promise.resolve();
      addingProtect = true;
      return post("/cart/add.js", { id: PROTECT_VID, quantity: 1 })
        .then(function () { addingProtect = false; return syncTotals(); })
        .catch(function () { addingProtect = false; });
    }
    function removeLineSilent(key) { return post("/cart/change.js", { id: key, quantity: 0 }).then(function () { return syncTotals(); }).catch(function () {}); }
    function queueQty(key, qty) {
      if (qtyTimers[key]) clearTimeout(qtyTimers[key]);
      qtyTimers[key] = setTimeout(function () {
        delete qtyTimers[key];
        post("/cart/change.js", { id: key, quantity: qty }).then(function () { return syncTotals(); }).catch(function () {});
      }, 320);
    }

    function render(cart) {
      lastCart = cart;
      var items = realItems(cart);
      var prot = findProtect(cart);
      setCounts(realCount(cart));

      if (!items.length) {
        if (prot) { removeLineSilent(prot.key); return; }   // strip orphan protection
        foot.hidden = true;
        body.innerHTML =
            '<div class="kcart__empty"><p>Your bag is empty.</p>'
          + '<a class="k-btn k-btn--primary" href="/products/collagen-glow-renewal-mask">Shop the mask</a></div>';
        return;
      }

      var html = '<div class="kcart__ship kship" id="kcartShip"></div><ul class="kcart__items">';
      items.forEach(function (it) {
        /* The Founding Drop supplies its approved bundle photograph as a private
           line-item property. Other products continue to use Shopify's variant image. */
        var customImg = it.properties && it.properties._korena_cart_image;
        var foundingThumb = window.KorenaCartConfig && window.KorenaCartConfig.foundingThumbnail;
        var fourPackThumb = window.KorenaCartConfig && window.KorenaCartConfig.fourPackThumbnail;
        var img = Number(it.variant_id) === 53307483553903 && typeof fourPackThumb === "string"
          ? fourPackThumb
          : isFounding(it) && typeof foundingThumb === "string"
          ? foundingThumb
          : (typeof customImg === "string" && /^(?:https?:)?\/\/[^\"'<>\\\s]+$/i.test(customImg))
            ? customImg
            : thumb(it.image);
        var unit = it.quantity ? Math.round(it.final_line_price / it.quantity) : it.final_line_price;
        var compareTotal = comparisonTotal(it, (window.KorenaCartComparePrices || {})[it.variant_id]);
        var compareUnit = it.quantity ? compareTotal / it.quantity : 0;
        var ledOffer = Number(it.variant_id)===67781155487855 || Number(it.variant_id)===67952743579759;
        var itemTitle = ledOffer ? (it.variant_title || it.product_title).toUpperCase() : it.product_title;
        var variant = (!ledOffer && it.variant_title && it.variant_title !== "Default Title" && it.variant_title !== it.product_title)
          ? '<div class="kcart__variant">' + it.variant_title + '</div>' : '';
        var planName = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan && it.selling_plan_allocation.selling_plan.name;
        var plan = planName ? '<div class="kcart__variant">Plan: ' + planName + '</div>' : '';
        html +=
            '<li class="kcart__item" data-key="' + it.key + '" data-unit="' + unit + '" data-compare-unit="' + compareUnit + '">'
          +   '<a class="kcart__thumb" href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>'
          +   '<div class="kcart__info">'
          +     '<div class="kcart__top">'
          +       '<a class="kcart__name" href="' + it.url + '">' + itemTitle + '</a>'
          +       '<span class="kcart__price"><span data-kcart-current>' + money(it.final_line_price) + '</span>' + (compareTotal ? '<s class="kcart__was" data-kcart-was>' + money(compareTotal) + '</s>' : '') + '</span>'
          +     '</div>'
          +     variant + plan + includesHTML(it.handle) + extrasHTML(it)
          +     '<div class="kcart__row">'
          +       '<div class="kcart__qty">'
          +         '<button type="button" aria-label="Decrease quantity" data-kcart-dec>−</button>'
          +         '<span class="kcart__qn">' + it.quantity + '</span>'
          +         '<button type="button" aria-label="Increase quantity" data-kcart-inc>+</button>'
          +       '</div>'
          +       '<button type="button" class="kcart__remove" aria-label="Remove from bag" data-kcart-remove>'
          +         '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>'
          +       '</button>'
          +     '</div>'
          +   '</div>'
          + '</li>';
      });
      html += '</ul>';
      /* Cross-sell: one honest offer, only when the 4-Pack is not already in the bag. */
      var xs = window.KorenaCartConfig && window.KorenaCartConfig.crossSell;
      if (xs && !items.some(function (it) { return it.variant_id === xs.id; })) {
        html +=
            '<div class="kcart__xsell">'
          +   '<a class="kcart__xsell-img" href="' + xs.url + '"><img src="' + xs.image + '" alt="" loading="lazy"></a>'
          +   '<div class="kcart__xsell-txt"><span class="kcart__xsell-t">' + xs.title + '</span><span class="kcart__xsell-s">4 treatments · ' + xs.price + '</span></div>'
          +   '<button type="button" class="kcart__xsell-btn" data-kcart-xsell="' + xs.id + '">Add</button>'
          + '</div>';
      }
      body.innerHTML = html;

      // protection: opt-in. Reflect actual cart state, never auto-add.
      // Founding Drop in the bag = protection included free: lock the switch on and
      // strip any PAID protection line so the customer is never charged for it.
      var ledFree = (cart.items || []).some(function(it){return Number(it.variant_id)===67781155487855 || Number(it.variant_id)===67952743579759;}), founding = hasFounding(cart) || ledFree;
      var displayTotal = cart.total_price;
      if (founding && prot) { removeLineSilent(prot.key); displayTotal -= PROTECT_PRICE; prot = null; }
      var willProtect = !!prot;
      protectEl.innerHTML = protectRow(willProtect, founding, ledFree);
      setSubtotal(displayTotal);
      foot.hidden = false;
    }

    // ---- Init any on-page shipping bars (e.g. the PDP buy box) with the real cart total ----
    if (document.querySelector("[data-kship]")) {
      getCart().then(function (c) { lastCart = c; updateShipBars(c.total_price); }).catch(function () {});
    }

    // ---- Cross-sell add (delegated; the block is re-rendered with the bag) ----
    body.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-kcart-xsell]"); if (!btn) return;
      btn.disabled = true; btn.textContent = "Adding";
      post("/cart/add.js", { id: parseInt(btn.getAttribute("data-kcart-xsell"), 10), quantity: 1 })
        .then(function () { return getCart().then(render); })
        .catch(function () { btn.disabled = false; btn.textContent = "Add"; });
    });

    // ---- Open from the nav bag icon ----
    var bag = document.getElementById("bagBtn");
    if (bag) {
      bag.addEventListener("click", function (e) {
        e.preventDefault();
        body.innerHTML = '<div class="kcart__loading">Loading your bag...</div>';
        open();
        refresh();
      });
    }

    // ---- Intercept every add-to-cart form ----
    Array.prototype.forEach.call(document.querySelectorAll('form[action^="/cart/add"]'), function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.setAttribute("data-loading", "true"); btn.disabled = true; }
        fetch("/cart/add.js", { method: "POST", headers: { "Accept": "application/json" }, body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
          .then(function () { body.innerHTML = '<div class="kcart__loading">Loading your bag...</div>'; open(); return refresh(); })
          .then(function () { if (btn) { btn.removeAttribute("data-loading"); btn.disabled = false; } })
          .catch(function () { if (btn) { btn.disabled = false; } form.submit(); }); // graceful fallback
      });
    });

    // ---- Drawer controls (delegated, optimistic) ----
    panel.addEventListener("click", function (e) {
      if (e.target.closest("[data-kcart-close]")) { close(); return; }

      // shipping protection toggle: instant flip, reconcile in background
      var sw = e.target.closest("[data-kcart-protect]");
      if (sw) {
        var turningOn = sw.getAttribute("aria-checked") !== "true";
        sw.setAttribute("aria-checked", turningOn ? "true" : "false");
        setProtectOff(!turningOn);
        bumpSubtotal(turningOn ? PROTECT_PRICE : -PROTECT_PRICE);
        if (turningOn) { addProtectSilent(); }
        else { var prot = lastCart ? findProtect(lastCart) : null; if (prot) removeLineSilent(prot.key); }
        return;
      }

      var li = e.target.closest(".kcart__item");
      if (!li) return;
      var key = li.getAttribute("data-key");
      var qn = li.querySelector(".kcart__qn");
      var q = qn ? parseInt(qn.textContent, 10) : 1;
      var unit = unitOf(li);

      if (e.target.closest("[data-kcart-remove]")) {
        bumpSubtotal(-(unit * q)); li.remove(); removeLineSilent(key);
        return;
      }
      var inc = !!e.target.closest("[data-kcart-inc]");
      var dec = !!e.target.closest("[data-kcart-dec]");
      if (inc || dec) {
        var newQ = inc ? q + 1 : q - 1;
        if (newQ <= 0) { bumpSubtotal(-(unit * q)); li.remove(); removeLineSilent(key); return; }
        qn.textContent = newQ;
        var pr = li.querySelector("[data-kcart-current]"); if (pr) pr.textContent = money(unit * newQ);
        var was = li.querySelector("[data-kcart-was]"); if (was) was.textContent = money(Number(li.dataset.compareUnit) * newQ);
        bumpSubtotal(unit * (newQ - q));
        queueQty(key, newQ);
      }
    });
    scrim.addEventListener("click", close);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && panel.dataset.open === "true") close();
    });

    // ---- On load: sync the bag badge + strip any orphan protection (cart with no real items) ----
    getCart().then(function (cart) {
      updateBadge(realCount(cart));
      if (realItems(cart).length === 0 && findProtect(cart)) { post("/cart/change.js", { id: findProtect(cart).key, quantity: 0 }); }
    }).catch(function () {});

    // ---- /cart page: shipping-protection toggle (optimistic), mirrors the drawer ----
    function parseMoney(t) { return Math.round(parseFloat((t || "0").replace(/[^0-9.]/g, "")) * 100) || 0; }
    function bumpCartPage(delta) {
      var s = document.getElementById("cartSubtotalV"), t = document.getElementById("cartTotalV");
      var nextSubtotal = s ? parseMoney(s.textContent) + delta : 0;
      if (s) s.textContent = money(nextSubtotal);
      if (t) t.textContent = money(parseMoney(t.textContent) + delta);
      updateShipBars(nextSubtotal);
    }
    function reconcileCartPage() {
      getCart().then(function (cart) {
        var s = document.getElementById("cartSubtotalV"), t = document.getElementById("cartTotalV"), i = document.getElementById("cartItemsV");
        if (s) s.textContent = money(cart.items_subtotal_price);
        if (t) t.textContent = money(cart.total_price);
        if (i) i.textContent = realCount(cart);
        updateShipBars(cart.items_subtotal_price);
        updateBadge(realCount(cart));
      }).catch(function () {});
    }
    document.addEventListener("click", function (e) {
      var sw = e.target.closest("[data-cartprotect]");
      if (!sw) return;
      var turningOn = sw.getAttribute("aria-checked") !== "true";
      sw.setAttribute("aria-checked", turningOn ? "true" : "false");
      setProtectOff(!turningOn);
      bumpCartPage(turningOn ? PROTECT_PRICE : -PROTECT_PRICE);
      if (turningOn) { post("/cart/add.js", { id: PROTECT_VID, quantity: 1 }).then(reconcileCartPage).catch(function () {}); }
      else { getCart().then(function (cart) { var prot = findProtect(cart); if (prot) post("/cart/change.js", { id: prot.key, quantity: 0 }).then(reconcileCartPage); }); }
    });

    // ---- Read-only QA hook: ?kcart=open opens the current bag ----
    try { if (/[?&]kcart=open/.test(location.search)) { open(); refresh(); } } catch (e) {}
  });
})();
